import { Color } from '@medly-components/theme';

const yellow: Color = {
    50: '#FFF8E6',
    100: '#FEEAB0',
    200: '#FEE08A',
    300: '#FED254',
    400: '#FDC9334',
    500: '#FDBC00',
    600: '#E6AB00',
    700: '#B48500',
    800: '#8B6700'
};

export default yellow;
